'use client'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

interface Props {
    name: string
    quality: string
}
export default function ProductDetailBreadcrumbs({ name, quality }: Props) {
    const { t } = useTranslation()

    return (
        <div className="text-base breadcrumbs mb-6 px-6 lg:px-0 ">
            <ul>
                <li>
                    <Link href={'/eshop'}>
                        {t('eshop.productdetail.breadcrumbs.products')}
                    </Link>
                </li>
                <li>
                    <span className="text-primary">
                        {name} - {quality}
                    </span>
                </li>
            </ul>
        </div>
    )
}
